import React from "react";
import { Icon, IconTypes } from "@foris/avocado-icons";
import { Text, Tooltip } from "@foris/avocado-suite";
import LinkRouter from "@common/components/link-router";
import cx from "classnames";
import styles from "./itemInfoRow.module.scss";

interface ItemInfoRowProps {
  className?: string;
  columns?: {
    icon?: IconTypes;
    title: string;
    text?: string;
    link?: string;
    isTextTruncated?: boolean;
    isVertical?: boolean;
    tooltipPosition?:
      | "top"
      | "bottom"
      | "left"
      | "right"
      | "topLeft"
      | "topRight"
      | "bottomLeft"
      | "bottomRight";
    customContent?: React.ReactNode;
  }[];
}

const ItemInfoRow = ({ columns = [], className = "" }: ItemInfoRowProps) => {
  if (!columns.length) return null;

  return (
    <div className={cx(styles.itemInfoRow, className)}>
      {columns?.map((col, key) => (
        <div key={key} className={styles.itemInfoRow_column}>
          {col?.icon && <Icon className={styles.columnIcon} name={col?.icon} size="md" />}

          <div className={cx(styles.columnText, col?.isVertical && styles.columnText__vertical)}>
            <Text weight="medium" className={styles.columnText_label}>
              {col?.title}
            </Text>

            {col?.customContent ? (
              col?.customContent
            ) : col?.link ? (
              <Tooltip
                label={col?.text}
                visible={!col?.isTextTruncated ? false : undefined}
                placement={col?.tooltipPosition}
              >
                <LinkRouter
                  className={cx(
                    styles.columnText_link,
                    col?.isTextTruncated && styles.columnText_link__truncated,
                  )}
                  to={col?.link}
                >
                  {col?.text ?? "-"}
                </LinkRouter>
              </Tooltip>
            ) : (
              <Tooltip
                label={col?.text}
                visible={!col?.isTextTruncated ? false : undefined}
                placement={col?.tooltipPosition}
              >
                <Text
                  className={cx(
                    styles.columnText_text,
                    col?.isTextTruncated && styles.columnText_text__truncated,
                  )}
                >
                  {col?.text ?? "-"}
                </Text>
              </Tooltip>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ItemInfoRow;
